import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { getTrustpilot } from '@services/my-home'
import styles from './styles.scss';
const RatingSection: FC = () => {
	const { width } = useResizeObserver();
	const { transData, list, score } = useTranslation('home.rating');
	const htmlRef = useRef<HTMLDivElement>(null);
	const [trustScore, setTrustScore] = useState(score)

	const itemList = (list as any[]).map((item, index) => {
		return (
			<div
				className={classnames(styles['ac-home-comment-item'], styles[`ac-home-comment-item-${item.id}`], `ac-home-comment-item-${item.id}`)}
				key={index}>
				<div className={styles['ac-home-comment-header']}>
					<div className={styles['ac-home-comment-avatar']}>
						<img src={item.img} alt="" />
					</div>
					<div className={styles['ac-home-comment-icon']}>
						<span className={styles['ac-home-comment-name']}>{item.name}</span>
						<img loading="lazy" src={transData.starts} alt="" />
					</div>
				</div>
				<div className={styles['ac-home-comment-title']}>{item.title}</div>

				<div className={styles['ac-home-comment-item-context']}>
					<p>{item.content}</p>
					<span className={styles['date']}>{item.date}</span>
				</div>
			</div>
		);
	});
	const phoneBetween = width < 768 ? 16 : 24;
	const spaceBetween = width >= 1192 ? 32 : phoneBetween;

	const TrustpilotWidget = useMemo(() => {
		return (
			<div
				className="trustpilot-widget"
				data-locale="en-US"
				data-template-id="56278e9abfbbba0bdcd568bc"
				data-businessunit-id="61126099553d54001d7abc98"
				data-style-height="52px"
				data-style-width="100%">
				<a href="https://www.trustpilot.com/review/air-class.com" target="_blank" rel="noopener">
					Trustpilot
				</a>
			</div>
		);
	}, []);

	const renderTrustpilot = () => {
		// 手动控制trustpilot在每次进入页面时都会重新加载渲染
		const oldScript = document.getElementById('trustpilot-widget');
		if (oldScript) {
			if (window.Trustpilot) {
				delete window.Trustpilot;
			}
			oldScript.remove();
		}
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.id = 'trustpilot-widget';
		script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
		script.async = true;
		document.getElementsByTagName('head')[0].appendChild(script);
	};

	const getTrustpilotHandle = async () => {
		const res = await getTrustpilot()
		setTrustScore(res?.data?.trustScore || score)

	}

	useEffect(() => {
		renderTrustpilot();
		getTrustpilotHandle()
	}, []);

	return (
		<section className={styles['ac-home-comment']}>
			<div className={styles['ac-home-comment-container']}>
				<h1>{transData.title}</h1>
				<div className={styles['comment-wrap']}>
					<span className={styles['excellent']}>{transData.excellent}</span>
					<div className={styles['icon']}>
						<img loading="lazy" src={transData.starts} alt="" />
						<span>{ trustScore }</span>
					</div>
					<div className={styles['reviews']} ref={htmlRef}>
						{TrustpilotWidget}
					</div>
				</div>
				<AcSwipe
					className={classnames(styles['ac-home-comment-banner'], 'ac-home-comment-banner')}
					loop
					spaceBetween={spaceBetween}
					autoplay={width < 1192 ? {
						delay: 5000,
						disableOnInteraction: false,
					} : false}
					slidesPerView={width >= 1192 ? 3 : 'auto'}
					allowTouchMove={width < 1192}
					pagination={width < 1192 ? { clickable: true } : false}>
					{itemList}
				</AcSwipe>
			</div>
		</section>
	);
};

export default RatingSection;
